import React, { useEffect, useMemo, useState } from 'react';
import Select from 'react-select';
import { FixedSizeList as List } from 'react-window';

export const SelectTimeZone = ({ onSelect, initialValue }) => {
  const [value, setValue] = useState();

  // Генерируем массив опций UTC
  const utcOptions = useMemo(() => {
    const options = [];

    for (let hour = -20; hour <= 20; hour++) {
      [30, 0].forEach((minute) => {
        const formattedHour = `${hour < 0 ? '-' : '+'}${String(Math.abs(hour)).padStart(2, '0')}`;
        const formattedMinute = String(minute).padStart(2, '0');
        const utcString = `${formattedHour}:${formattedMinute}:00`;

        options.push({
          value: utcString,
          label: utcString, // Используем то же значение для отображения
        });
      });
    }

    return options;
  }, []);

  useEffect(() => {
    if (initialValue && utcOptions.length > 0) {
      const value = initialValue.startsWith('-') ? initialValue : `+${initialValue}`;
      setValue(utcOptions.find((i) => i.value === value));
    }
  }, [initialValue, utcOptions]);

  // Обработчик выбора
  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setValue(selectedOption);
      console.log(onSelect);
      onSelect(selectedOption.value); // Возвращаем строку в формате ±HH:MM:00
    }
  };
  return (
    <Select
      options={utcOptions}
      components={{ MenuList }}
      value={value}
      onChange={handleChange}
      placeholder="Выберите UTC..."
      isSearchable={true} // Включает поиск
      noOptionsMessage={() => 'Нет совпадений'} // Сообщение при отсутствии результатов
    />
  );
};

const MenuList = (props) => {
  const { options, children, maxHeight, getValue } = props;
  const height = 35; // Высота одной строки

  const [value] = getValue();
  const initialOffset = options.findIndex((option) => option.value === value?.value) * height;

  return (
    <List
      height={maxHeight}
      itemCount={options.length}
      itemSize={height}
      initialScrollOffset={initialOffset}
      width="100%"
    >
      {({ index, style }) => (
        <div style={style}>
          {children[index]} {/* Отображение только видимого элемента */}
        </div>
      )}
    </List>
  );
};
